"use client";

import { motion, useReducedMotion } from "framer-motion";
import type { SocialLink } from "@/lib/social-links";
import { SOCIAL_ICONS } from "@/lib/social-links";

interface FooterSocialLinksProps {
  links: SocialLink[];
}

export function FooterSocialLinks({ links }: FooterSocialLinksProps) {
  const reduced = useReducedMotion();

  if (links.length === 0) return null;

  return (
    <>
      <h3 className="footer-heading mt-4 mb-2 text-sm font-semibold text-accent">
        Follow Us
      </h3>
      <div className="flex gap-2">
        {links.map(({ platform, href, label }) => {
          const Icon = SOCIAL_ICONS[platform];
          return (
            <motion.a
              key={platform}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              whileHover={reduced ? undefined : { scale: 1.06 }}
              whileTap={reduced ? undefined : { scale: 0.96 }}
              transition={{ duration: 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="footer-social-link flex h-9 w-9 items-center justify-center rounded-full border transition-colors"
            >
              <Icon size={16} />
            </motion.a>
          );
        })}
      </div>
    </>
  );
}
